import { useEffect } from 'react';

async function fetchVersion(versionPath: string) {
    try {
        const response = await fetch(`${versionPath}version.json`);
        const data = await response.json();
        return data.version;
    } catch (error) {
        console.error('Failed to fetch version:', error);
        return null;
    }
}

function useVersionChecker(versionKey: string, versionPath: string) {
    useEffect(() => {
        if (typeof window === 'undefined' || !window.sessionStorage) {
            return;
        }

        const checkVersion = async (initialLoad: boolean) => {
            const currentVersion = await fetchVersion(versionPath);
            const storedVersion = sessionStorage.getItem(versionKey);

            if (currentVersion && currentVersion !== storedVersion) {
                sessionStorage.setItem(versionKey, currentVersion);
                if (!initialLoad) window.location.reload();
            } else if (!storedVersion) {
                sessionStorage.setItem(versionKey, currentVersion);
            }
        };

        checkVersion(true);

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                checkVersion(false);
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener(
                'visibilitychange',
                handleVisibilityChange
            );
        };
    }, [versionKey]);
}

export default useVersionChecker;
